"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabLabelVerticalSpacing = exports.tabLabelSpacingClassName = exports.TabLabel = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./TabLabel.css");
var _usePreviousValue = require("@cbhq/cds-common/hooks/usePreviousValue");
var _collapsible = require("../collapsible");
var _DotCount = require("../dots/DotCount");
var _useDimensions2 = require("../hooks/useDimensions");
var _useIsoEffect = require("../hooks/useIsoEffect");
var _layout = require("../layout");
var _tokens = require("../tokens");
var _typography = require("../typography");
const _excluded = ["id", "active", "variant", "count", "max", "onLayout", "Component"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const tabLabelVerticalSpacing = 2;
exports.tabLabelVerticalSpacing = tabLabelVerticalSpacing;
const tabLabelSpacingClassName = "cds-tabLabelSpacingClassName-t1j7dqxh";
exports.tabLabelSpacingClassName = tabLabelSpacingClassName;
const containerClassName = "cds-containerClassName-c9hvdip";
const hiddenClassName = "cds-hiddenClassName-h1m2ekx0";
const COLORS = {
  primary: {
    active: 'primary',
    inactive: 'foreground'
  },
  secondary: {
    active: 'foreground',
    inactive: 'foregroundMuted'
  }
};
const TabLabel = /*#__PURE__*/(0, _react.memo)(_ref => {
  var _props$accessibilityL, _ref2;
  let _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    active = _ref.active,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    max = _ref.max,
    onLayout = _ref.onLayout,
    Component = _ref.Component,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const shouldMeasureElement = (0, _react.useMemo)(() => !active && variant !== 'primary', [active, variant]);
  const color = (0, _react.useMemo)(() => COLORS[variant][active ? 'active' : 'inactive'], [active, variant]);
  const prevCount = (0, _usePreviousValue.usePreviousValue)(count);
  const accessibilityLabelId = (0, _react.useId)();
  const TextElement = (0, _react.useMemo)(() => {
    if (variant === 'primary') return _typography.TextHeadline;
    if (active) return _typography.TextTitle3;
    return _typography.TextTitle4;
  }, [active, variant]);

  // Handle layout events
  const _useDimensions = (0, _useDimensions2.useDimensions)(),
    observe = _useDimensions.observe,
    width = _useDimensions.width,
    x = _useDimensions.x;
  const getOnLayoutHandler = (0, _react.useCallback)(() => {
    onLayout === null || onLayout === void 0 ? void 0 : onLayout(id, {
      width,
      x
    });
  }, [id, onLayout, width, x]);
  (0, _useIsoEffect.useIsoEffect)(() => {
    getOnLayoutHandler();
  }, [getOnLayoutHandler]);
  return /*#__PURE__*/_react.default.createElement(_layout.HStack, {
    ref: observe,
    alignItems: "center"
  }, shouldMeasureElement && /*#__PURE__*/_react.default.createElement("span", {
    className: containerClassName
  }, Component ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Component, {
    active: active,
    id: id,
    label: props.children
  }), /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true",
    className: hiddenClassName
  }, /*#__PURE__*/_react.default.createElement(Component, {
    active: active,
    id: id,
    label: props.children
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TextElement, _extends({
    as: "h2",
    color: color
  }, props)), /*#__PURE__*/_react.default.createElement(TextElement, _extends({
    as: "h2",
    color: color
  }, props, {
    "aria-hidden": "true",
    className: hiddenClassName
  })))), !shouldMeasureElement && (Component ? /*#__PURE__*/_react.default.createElement(Component, {
    active: active,
    id: id,
    label: props.children
  }) : /*#__PURE__*/_react.default.createElement(TextElement, _extends({
    as: "h2",
    color: color,
    id: accessibilityLabelId
  }, props, {
    className: variant === 'primary' ? tabLabelSpacingClassName : undefined
  }))), /*#__PURE__*/_react.default.createElement(_collapsible.Collapsible, {
    collapsed: !count,
    direction: "horizontal",
    role: "status",
    spacingStart: 0.5
  }, /*#__PURE__*/_react.default.createElement(_DotCount.DotCount, {
    accessibilityLabel: `${((_props$accessibilityL = props.accessibilityLabel) !== null && _props$accessibilityL !== void 0 ? _props$accessibilityL : typeof props.children === 'string') ? props.children : ''} count: ${count}`,
    count: (_ref2 = count || prevCount) !== null && _ref2 !== void 0 ? _ref2 : 0,
    max: max
  })));
});
exports.TabLabel = TabLabel;
TabLabel.displayName = 'TabLabel';